import {mapGetters} from 'vuex'
import {mapActions} from 'vuex'

export default {
    apiMixin: {
        methods: {
            ...mapActions([
              'clearState',
            ]),
            logout() {
                this.clearState();
                this.$router.push("/");
            }

        },
        computed: {
            ...mapGetters([
                'getUser',
            ]),

            retailerGroupHandle() {
                var result = {};
                var regexParse = new RegExp('([a-z\-0-9]{2,63})\.([a-z\.]{2,5})$');
                var urlParts = regexParse.exec(window.location.hostname);
                result.domain = urlParts[1];
                result.type = urlParts[2];
                result.subdomain = window.location.hostname.replace(result.domain + '.' + result.type, '').slice(0, -1);


                // developmen mode
                result.subdomain = result.subdomain == "localhos" ? "ham" : result.subdomain;
                return result.subdomain;

            },


            apiHeaders() {
                let config = {
                    headers: {}
                };
                config.headers.Version = "2018-06-27";

                if (this.getUser.hasOwnProperty("token")) {
                    config.headers.Authorization = "Bearer " + this.getUser.token;
                }
                return config;
            }

        },
    }
}